import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ProjectResponseDto } from '../dto/response/project-response.dto';
import { EnrichedProjectResponseDto } from '../dto/response/enriched-project-response.dto';
import projectService from '../services/project.service';
import { ProjectSaveRequestDto } from '../dto/request/project-save-request.dto';
// import { ProjectUpdateRequestDto } from '../dto/request/project-update-request.dto';
import { showError, showSuccess } from '../../../../utils/Notifications';
import { LocalesLanguagesConstants } from '../../../../locales/locales';

const initialState = {
  status: 'idle',
  enrichedProjects: [] as EnrichedProjectResponseDto[] | null,
  enrichedProject: null as EnrichedProjectResponseDto | null,
  projects: [] as ProjectResponseDto[] | null,
  project: null as ProjectResponseDto | null,
  error: null as string | null,
};

// export const fetchProjects = createAsyncThunk(
//   'projects/fetchProjects',
//   async () => {
//     return await projectService.fetchProjects();
//   }
// );

export const fetchProjectById = createAsyncThunk(
  'projects/fetchProjectById',
  async (params: { id: string; language: LocalesLanguagesConstants }) => {
    return await projectService.fetchProjectById(params.id, params.language);
  }
);

export const fetchProjectsByLandscapeId = createAsyncThunk(
  'projects/fetchProjectsByLandscapeId',
  async (landscapeId: string) => {
    return projectService.fetchProjectsByLandscapeId(landscapeId);
  }
);

// export const fetchProjectsByLandscapeIds = createAsyncThunk(
//   'projects/fetchProjectsByLandscapeIds',
//   async (landscapeIds: string[]) => {
//     return projectService.fetchProjectsByLandscapeIds(landscapeIds);
//   }
// );

export const saveProject = createAsyncThunk(
  'projects/saveProject',
  async (parms: {
    saveRequest: ProjectSaveRequestDto;
    language: LocalesLanguagesConstants;
  }) => {
    return await projectService.saveProject(parms.saveRequest, parms.language);
  }
);

// export const updateProject = createAsyncThunk(
//   'projects/updateProject',
//   async (params: {
//     updateRequest: ProjectUpdateRequestDto;
//     language: LocalesLanguagesConstants;
//   }) => {
//     return await projectService.updateProject(
//       params.updateRequest,
//       params.language
//     );
//   }
// );

export const deleteProject = createAsyncThunk(
  'projects/deleteProject',
  async (params: { id: string; compactId: string }) => {
    const { id, compactId } = params;
    return await projectService.deleteProject(id, compactId);
  }
);

const projectSlice = createSlice({
  name: 'projectSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchProjects.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchProjects.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.enrichedProjects = action.payload;
      // })
      // .addCase(fetchProjects.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(fetchProjectsByLandscapeId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjectsByLandscapeId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projects = action.payload;
      })
      .addCase(fetchProjectsByLandscapeId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      // .addCase(fetchProjectsByLandscapeIds.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchProjectsByLandscapeIds.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.projects = action.payload;
      // })
      // .addCase(fetchProjectsByLandscapeIds.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(fetchProjectById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjectById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.enrichedProject = action.payload;
      })
      .addCase(fetchProjectById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(saveProject.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveProject.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projects?.push(action.payload);
      })
      .addCase(saveProject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      // .addCase(updateProject.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateProject.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   if (state.projects) {
      //     const projectIndex = state.projects.findIndex(
      //       (project) => project.id === action.payload.id
      //     );
      //     if (projectIndex !== -1) {
      //       state.projects[projectIndex] = action.payload;
      //     }
      //   }
      // })
      // .addCase(updateProject.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(deleteProject.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteProject.fulfilled, (state) => {
        state.status = 'succeeded';
        showSuccess('Project deleted successfully!');
      })
      .addCase(deleteProject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
        showError('Error while deleting project!');
      });
  },
});

export default projectSlice.reducer;
